const initialState = {
  liveChatScreenOpen: false,
  liveChatAddContactOpen: false,
  liveChatAddGroupOpen: false,
  liveChatSelectContact: "",
}

const liveChat = (state = initialState, action) => {
  switch (action.type) {

    case "SET_LIVE_CHAT_STATE": {
      const liveChatState = action.payload.state;
      return { ...state, state: liveChatState };
    }

    case "SET_LIVE_CHAT_SCREEN_OPEN": {
      const { liveChatScreenOpen } = action.payload;
      return { ...state, liveChatScreenOpen };
    }

    case "SET_LIVE_CHAT_ADD_CONTACT_OPEN": {
      const { liveChatAddContactOpen } = action.payload;
      return { ...state, liveChatAddContactOpen };
    }

    case "SET_LIVE_CHAT_ADD_GROUP_OPEN": {
      const { liveChatAddGroupOpen } = action.payload;
      return { ...state, liveChatAddGroupOpen };
    }

    case "SET_LIVE_CHAT_SELECT_CONTACT": {
      const { liveChatSelectContact } = action.payload;
      return { ...state, liveChatSelectContact };
    }

    default:
      return state;
  }
};

export default liveChat;
